import { EyeOutlined, MoreOutlined } from '@ant-design/icons'
import { Button, Dropdown, Space } from 'antd'
import ButtonGroup from 'antd/es/button/button-group'
import { MenuProps } from 'antd/lib'
import { FC } from 'react'
import PreviewShipmentBlank from '../../../../../../../../components/buttons/preview-shipment-blank/preview-shipment-blank'
import RoleGuard from '../../../../../../../../components/role-guard/role-guard'
import { useUpdatePrintQueueEntryMutation } from '../../../../../../../../store/api/print-queue-entries-api'
import PrintQueueEntry, { Zones } from '../../../../../../../../types/api/print-queue-entry'
import { PRINT_PLAN_EDIT_ROLES } from '../../../../../constants/print-plan-edit-roles'

interface ActionsCellProps {
    printQueueEntry: PrintQueueEntry
}

const ActionsCell: FC<ActionsCellProps> = ({ printQueueEntry }) => {
    const [updatePrintQueueEntry] = useUpdatePrintQueueEntryMutation()

    const onMoveToWaitingZone = () => {
        updatePrintQueueEntry({
            docId: printQueueEntry.documentId,
            body: {
                data: {
                    zone: Zones.Waiting,
                },
            },
        })
    }

    const items: MenuProps['items'] = [
        {
            key: '1',
            label: 'В зону ожидания',
            onClick: onMoveToWaitingZone,
        },
    ]

    return (
        <RoleGuard requiredRoles={PRINT_PLAN_EDIT_ROLES}>
            <Space>
                <ButtonGroup>
                    <PreviewShipmentBlank
                        shipment={printQueueEntry.print_job?.shipment!}
                        blankType="production"
                        blankPreviewFiles={printQueueEntry.print_job?.shipment?.blankPreviewFiles}
                    >
                        <Button
                            title={'Посмотреть бланк'}
                            size={'small'}
                            icon={<EyeOutlined />}
                            color={'magenta'}
                            variant={'solid'}
                        />
                    </PreviewShipmentBlank>
                    {/* <Button
                        title={'Смотреть тех карту'}
                        size={'small'}
                        icon={<EyeOutlined />}
                        color={'cyan'}
                        variant={'solid'}
                    /> */}
                </ButtonGroup>
                <Dropdown menu={{ items }}>
                    <Button size={'small'} icon={<MoreOutlined />} type={'primary'} />
                </Dropdown>
            </Space>
        </RoleGuard>
    )
}

export default ActionsCell
